// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zone_root_nY65r {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  white-space: nowrap;
}

.zone_left_AcaMh {
  width: var(--left-width);
}

.zone_right_G6Tk5 {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: flex-start;
  padding-left: 15px;
  width: var(--right-width);
  box-sizing: border-box;
}

.zone_border_PVQu5 {
  height: 4px;
  width: 100%;
  margin-left: calc(-1 * (var(--left-width) + 20px + var(--line-width)));
  margin-top: 2px;
  margin-bottom: 2px;
}

.zone_line_cKUgv {
  width: 100%;
  height: 100%;
  stroke: rgb(135, 135, 135);
  stroke-width: 2px;
  stroke-linecap: round;
}

.zone_zoneHeading_PWE_U {
  font-family: GothamRounded-Book;
  font-size: 11px;
  vertical-align: middle;
  line-height: 1.1rem;
  display: flex;
  align-items: center;
  width: 100%;
}

.zone_zoneHeading_PWE_U strong {
  font-family: GothamRounded-Medium;
}

.zone_zoneIcon_WsZtL {
  display: inline-block;
  width: 1.3rem;
  height: 1.3rem;
  margin-left: 5px;
  padding: 0;
  font-family: GothamRounded-Medium;
  font-size: 1rem;
  text-align: center;
  line-height: 1.4;
  vertical-align: middle;
  letter-spacing: -0.025em;
  text-transform: uppercase;
  color: white;
  background: var(--line-color);
  border-radius: 50%;
}

.zone_noZone_UftRB {
  height: 12px;
}

.zone_separator_ioP2a {
  display: flex;
  flex-flow: column;
  align-items: flex-start;
}

.zone_separatorTop_KEbEA,
.zone_separatorBottom_gND2X {
  height: 22px;
  border-left: var(--line-border);
}

.zone_separatorMiddle_O5j9H {
  height: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/routeDiagram/zone.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sEAAsE;EACtE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb","sourcesContent":[".root {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  white-space: nowrap;\n}\n\n.left {\n  width: var(--left-width);\n}\n\n.right {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  align-items: flex-start;\n  padding-left: 15px;\n  width: var(--right-width);\n  box-sizing: border-box;\n}\n\n.border {\n  height: 4px;\n  width: 100%;\n  margin-left: calc(-1 * (var(--left-width) + 20px + var(--line-width)));\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n.line {\n  width: 100%;\n  height: 100%;\n  stroke: rgb(135, 135, 135);\n  stroke-width: 2px;\n  stroke-linecap: round;\n}\n\n.zoneHeading {\n  font-family: GothamRounded-Book;\n  font-size: 11px;\n  vertical-align: middle;\n  line-height: 1.1rem;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.zoneHeading strong {\n  font-family: GothamRounded-Medium;\n}\n\n.zoneIcon {\n  display: inline-block;\n  width: 1.3rem;\n  height: 1.3rem;\n  margin-left: 5px;\n  padding: 0;\n  font-family: GothamRounded-Medium;\n  font-size: 1rem;\n  text-align: center;\n  line-height: 1.4;\n  vertical-align: middle;\n  letter-spacing: -0.025em;\n  text-transform: uppercase;\n  color: white;\n  background: var(--line-color);\n  border-radius: 50%;\n}\n\n.noZone {\n  height: 12px;\n}\n\n.separator {\n  display: flex;\n  flex-flow: column;\n  align-items: flex-start;\n}\n\n.separatorTop,\n.separatorBottom {\n  height: 22px;\n  border-left: var(--line-border);\n}\n\n.separatorMiddle {\n  height: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `zone_root_nY65r`,
	"left": `zone_left_AcaMh`,
	"right": `zone_right_G6Tk5`,
	"border": `zone_border_PVQu5`,
	"line": `zone_line_cKUgv`,
	"zoneHeading": `zone_zoneHeading_PWE_U`,
	"zoneIcon": `zone_zoneIcon_WsZtL`,
	"noZone": `zone_noZone_UftRB`,
	"separator": `zone_separator_ioP2a`,
	"separatorTop": `zone_separatorTop_KEbEA`,
	"separatorBottom": `zone_separatorBottom_gND2X`,
	"separatorMiddle": `zone_separatorMiddle_O5j9H`
};
module.exports = ___CSS_LOADER_EXPORT___;
